import React from "react";

const skillsText = () => (
  <div className="mb-2 cursor-default">
    My expertise is creating entire web apps, building what users see, handling
    what happens behind the scenes, and storing data reliably. I've spent more
    than a year on improving my skills in{" "}
    <span className="font-bold text-gray-800 dark:text-white">
      web & app development
    </span>{" "}
    that I'm now pretty confident in building apps using these tools:
  </div>
);

export default skillsText;
